// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fLy_","field":"styles_field__3TF9o","fieldCol":"styles_fieldCol__2X1Bz","diffCol":"styles_diffCol__3CQRD","diff":"styles_diff__C6tvf"};